import React from 'react';
import PropTypes from 'prop-types';
import { getFares } from '../../../_integrations/everymundo/package';
import PackagesCarouselSkeleton from '../../others/Skeleton/SkeletonPackagesCarousel';
import FaresCarouselBackgroundImageContainer from '../FaresCarouselBackgroundImageContainer';

const PackagesCarouselContainerMobile = (props) => (
  <FaresCarouselBackgroundImageContainer
    SkeletonInstance={PackagesCarouselSkeleton}
    {...props}
    getFares={getFares}
  />
);

PackagesCarouselContainerMobile.componentName = 'PackagesCarouselContainerMobile';

PackagesCarouselContainerMobile.propTypes = {
  /**
   * Parameters tracking
   */
  tracking: PropTypes.objectOf(PropTypes.any)
};

PackagesCarouselContainerMobile.defaultProps = {
  tracking: {
    flexibleDates: false,
    passengerCount: 1,
    promoCode: 'EVERYMUNDO',
    eventType: 'packagesCarouselContainer'
  }
};

export default PackagesCarouselContainerMobile;
